import React from 'react'
import '../styles/introduce.css'
import Image from 'react-bootstrap/Image';
import 증명사진 from '../img/증명사진.jpg';
import Project from '../components/project';

const introduce = () => {
  return (
    <section className='introduce-sec' style={{ margin: '1px auto' }}>
      <div className='introduce-div'>
        <h2>ABOUT ME</h2>
        <div className='profile-inner'>
          <Image src={증명사진} thumbnail style={{ width: '200px' }} />
          <div>
            <ul>
              <li>이름 : 김준한</li>
              <li>생년월일 : 1997.04.25</li>
              <li>주거지 : 경기도 과천시</li>
              <li>이메일 : k0j4h25@hanmail.net</li>
              <li>학력 : 강원대학교 (춘천/환경공학과) 졸업</li>
            </ul>
          </div>
        </div>
      </div>

      <div className='license-div'>
        <div>
          <h2>Licenses & Certifications</h2>
          <ul>
            <li> 정보처리기사 (취득일 : 2026/06)</li>
            <li> 투자자산운용사 (취득일 : 2022/02)</li>
            <li> 운전면허 1종보통 (취득일 : 2017/01)</li>
          </ul>
        </div>
      </div>

      <div className='career-div'>
        <div>
          <h2>Career</h2>
          <ul>
            <li> (교육과정 이수) : 2023.02 ~ 2023.09 (KH정보교육원)
              풀스택 개발자 양성과정</li>
            <li> 2024.02 ~ 2025.07 (Bizbee - 솔루션개발 3팀 사원 재직)</li>
            <li> 2025.09 ~ ing (LandSoft (국립중앙박물관 근무) - 솔루션개발팀 매니저 재직)</li>
          </ul>
        </div>
      </div>


      <div className='project1-div' style={{ margin: '10px auto' }}>
        <h2>Project List</h2>
        <div className='project-inner' style={{ margin: '20px' }}>
          {/* 첫 번째 프로젝트  다가치 소모임 웹*/}
          <Project
            imgName="dagachi"
            title="다가치(dagachi) (개발)"
            description="취미를 공유하고 함께 즐길 수 있는 소모임 플랫폼으로, 사용자가 관심 있는 모임을 찾고 참여할 수 있도록 지원합니다."
            features={[
              "✅모임을 달력에 기록, 길안내까지",
              "✅친목을 도모하는 단체채팅",
              "✅내 마음대로 취향껏 고르는 레이아웃",
              "✅자신의 위치를 기준으로 고르는 모임",
            ]}
            stack="JavaScript,JQuery,Bootstrap,Java,Oracle,SpringBoot,GitHub,JSP"
            url="https://github.com/newTypeo/dagachi"
          />

          {/* 두번째 프로젝트 복지몰 */}
          <Project
            imgName="buyis"
            title="복지몰Buyis (웹) (유지보수/부분개발)"
            description="제휴사 임직원들을 위한 복지몰(폐쇄몰)"
            features={[
              "✅온라인 최저가 연동 시스템",
              "✅기업을 위한 폐쇄몰 시스템",
              "✅폐쇄 도메인 연동",
            ]}
            stack="JavaScript,JQuery,Java,PostgreSql,Spring,Tomcat,JSP,GitLab"
            url="https://www.buyis.co.kr"
          />

          {/* 세번째 프로젝트 복지몰 */}
          <Project
            imgName="scm"
            title="SCM관리자 (웹) (유지보수/부분개발)"
            description="복지몰 관리자 및 복지찬스 관리자"
            features={[
              "✅복지몰 buyis 관리자 시스템",
              "✅상품 등록 및 수정 회원관리 웹",
              "✅복지찬스 관리자 시스템",
            ]}
            stack="JavaScript,JQuery,Java,PostgreSql,Spring,Tomcat,JSP,GitLab"
            url="https://scm.buyis.co.kr"
          />

          {/* 네번째 프로젝트 복지찬스 */}
          <Project
            imgName="bokjichance"
            title="복지찬스 (어플) (개발)"
            description="사내(공동)근로복지기금 서비스"
            features={[
              "✅사내(공동)근로복지기금 운영 및 기장,신고를 위한 어플",
              "✅복지기금 출연금을 카드,복지몰을 통해 자유롭게 사용",
              "✅제휴매장 바코드 결제 기능",
              "✅위치를 기반으로 한 매장안내",
            ]}
            stack="React Native,Java,PostgreSql,Spring,Tomcat,Docker,GitLab"
            url="https://www.smartwel.co.kr/pay"
          />

          {/* 다섯번째 프로젝트 복지찬스 가맹점주 */}
          <Project
            imgName="gamengg"
            title="복지찬스 가맹점주 (어플) (개발)"
            description="복지찬스를 이용하는 임직원들이 매장에 방문했을 때 혜택을 제공하기로 약정한 매장 사업자로 복지포인트 사용 및 주변 임직원들이 방문할 수 있도록 마케팅을 받는 사업자"
            features={[
              "✅쿠폰 발급 및 무료 복지찬스 알림기능",
              "✅스탬프 기능 (고객 스탬프 적립)",
              "✅신한카드 매출관리",
              "✅가맹점 홍보",
            ]}
            stack="React Native,Bootstrap,Java,PostgreSql,Spring,GitLab,Tomcat"
            url="https://play.google.com/store/apps/details?id=com.bokjimerchant.app&hl=ko"
          />

          {/* 여섯번째 프로젝트 내 개인 홈페이지 */}
          <Project
            imgName="homepage2"
            title="포폴용 홈페이지"
            description="개인 포트폴리오 및 자기계발"
            features={[
              "✅의견게시판을 통한 CRUD",
              "✅간단한 로그인 기능(jwt token)",
              "✅spring Security",
              "✅이메일 인증",
              "✅포트폴리오",
            ]}
            stack="React,AWS,Bootstrap,Java,Oracle,SpringBoot,GitHub,Docker"
            url="https://jhpage.link/"
          />

          {/* 일곱번째 프로젝트 내 개인 홈페이지 */}
          <Project
            imgName="ollama"
            title="private OLLAMA LLM"
            description="네트워크 연결이 없어도되는 LLM"
            features={[
              "✅개인 PC로 돌리는 LLM모델",
              "✅CLI로 질문하는 방식",
              "✅프로젝트 기반 분석LLM",
            ]}
            stack="Python,CMD,PowerShell,LLM,Ollama"
            url="https://github.com/kjh425/privateLLM"
          />

          {/* 여덟번째 프로젝트 국중박 */}
          <Project
            imgName="nmk"
            title="NMK 국립중앙박물관"
            description="국립중앙박물관 대표 홈페이지"
            features={[
              "✅국립중앙박물관 유지운영",
              "✅예약 시스템 및 전체적인 시스템 총괄",
              "✅CMS를 이용한 홈페이지 관리",
              "✅웹 접근성 및 웹 취약점 관리",
            ]}
            stack="JSP,Java,Oracle,GitLab,JavaScript,JQuery,Spring,Tomcat"
            url="https://www.museum.go.kr/MUSEUM/main/index.do"
          />

          {/* 아홉번째 프로젝트 AI뉴스레터*/}
          <Project
            imgName="AInews"
            title="AI News-Letter"
            description="AI를 활용한 뉴스요약 프로젝트"
            features={[
              "✅매일 이슈사항 정리",
              "✅AI를 활용한 카테고리별 뉴스요약",
              "✅파이썬을 활용한 구글뉴스 크롤링",
            ]}
            stack="Python,React,Docker,PostgreSql"
            url="https://jhpage.link/news"
          />

          {/* 열번째 프로젝트 AI하네스 편지 어플*/}
          <Project
            imgName="letter-app"
            title="Harness Letter-app"
            description="하네스 엔지니어링을 활용한 편지어플"
            features={[
              "✅Codex 하네스 엔지니어링을 활용한 어플개발",
              "✅미래의 나에게 하고픈 말",
              "✅힘들시절 지나서 나에게 하고싶은 말",
            ]}
            stack="Python,React Native,Docker,PostgreSql,Codex"
            url="https://github.com/kjh425/harness-letter-app"
          />

          {/* 열한번째 프로젝트 AI로만든 춤추는 고양이*/}
          <Project
            imgName="dancingCat"
            title="Dancing - cat"
            description="AI로만든 춤추는 고양이"
            features={[
              "✅Codex 하네스 엔지니어링을 활용한",
              "✅키보드에 반응하는",
              "✅애플리케이션",
            ]}
            stack="Codex,C#,PowerShell"
            url="https://github.com/kjh425/dancing-cat"
          />

          {/* 열두번째 프로젝트 캐치테이블 하네스 클론*/}
          <Project
            imgName="catchTable"
            title="캐치테이블 하네스 클론"
            description="AI로만든 캐치테이블 Clone"
            features={[
              "✅Codex Harness 캐치테이블 클론",
              "✅음식점 예약 웹앱",
              "✅vercel 및 railway 무료배포",
            ]}
            stack="Codex,Railway,Vercel,Python,React,Vite"
            url="https://frontend-coral-one-25.vercel.app"
          />
        </div>
      </div>
    </section>


  )
}

export default introduce